// extracted by mini-css-extract-plugin
module.exports = {"header":"SimpleHeader_header___sbvC","headerDesktop":"SimpleHeader_headerDesktop__1hyIv","headerLeftSide":"SimpleHeader_headerLeftSide__J9C10"};